import { apiClient } from "./client";

export interface GeoToberWallBuildUpItem {
  id: string;
  description: string;
  length?: number;
  width?: number;
  height?: number;
  net: number;
  unit: string;
  rate: number;
  labour: number;
  total: number;
}

export interface GeoToberWallBuildUpSpecification {
  id: string;
  name: string;
  type: string;
  category: string;
  items: GeoToberWallBuildUpItem[];
  netTotal: number;
  ohpPercent: number;
  ohpAmount: number;
  grandTotal: number;
  prelimsPercent?: number;
}

export interface GeoToberWallBuildUpRequest {
  tenderId: string;
  tenderName: string;
  tenderVersion: number;
  tobermoreColumnHeaders: Record<string, string>;
  tobermoreColumnDimensions: Record<string, string>;
  specifications: GeoToberWallBuildUpSpecification[];
}

export interface GeoToberWallBuildUpResponse {
  success: boolean;
  message?: string;
}

export interface GeoToberWallBuildUpGetResponse {
  tenderId: string;
  tenderName: string;
  tenderVersion: number;
  tobermoreColumnHeaders: Record<string, string>;
  tobermoreColumnDimensions: Record<string, string>;
  specifications: GeoToberWallBuildUpSpecification[];
}

export const geoToberWallBuildUpApi = {
  get: async (tenderName: string, tenderVersion: number): Promise<GeoToberWallBuildUpGetResponse | null> => {
    const response = await apiClient.get<GeoToberWallBuildUpGetResponse>(
      "/v3/geo-tober-wall-buildup",
      { params: { tenderName, tenderVersion } }
    );
    return response.data;
  },

  post: async (data: GeoToberWallBuildUpRequest): Promise<GeoToberWallBuildUpResponse> => {
    const response = await apiClient.post<GeoToberWallBuildUpResponse>(
      "/v3/geo-tober-wall-buildup",
      data
    );
    return response.data;
  },
};
